<template>
  <div class="hfq-content">
    <Header></Header>
    <div class="section section-1">
      <div class="scale-img">
        <img src="@/assets/images/weicai/aboutWe/main.jpg" alt="" />
      </div>
    </div>
    <div class="section-2">
      <div class="section-2-content">
        <div class="info">
          <h4>使命</h4>
          <p class="desc1">科技为本</p>
          <p class="desc2">创新金融服务 创造美好生活</p>
        </div>
        <div class="line"></div>
        <div class="info">
          <h4>愿景</h4>
          <p class="desc1">助力<span class="DINPro-Regular">500</span>+金融机构科技升级</p>
          <p class="desc2">服务<span class="DINPro-Regular">2</span>亿+年轻用户消费生活</p>
        </div>
      </div>
    </div>
    <div class="section-3">
      <h3>价值观</h3>
      <div class="content">
        <div class="img">
          <img src="../../assets/images/weicai/aboutWe/section-3.png" alt="" srcset="">
        </div>
        <ul class="list">
          <li v-for="item in list" :key="item.title">
            <p class="title">{{ item.title }}</p>
            <p class="desc">{{ item.desc }}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="section-4">
      <h3>员工活动</h3>
      <div class="content">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in swiperList"
              :key="index"
            >
              <div class="img"><img :src="item.imgUrl" alt="" /></div>
              <div class="info">
                <p class="title">{{ item.title }}</p>
                <p class="desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next" @click="next"></div>
        <div class="swiper-button-prev" @click="prev"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import Header from '@/components/header'
import Footer from '@/components/footer'
import newsList from '@/components/newsList.vue'

export default {
  components: {
    Header,
    Footer,
    newsList
  },
  data () {
    return {
      mySwiper: null,
      list: [
        {
          title: '拥抱变化',
          desc: '开放地迎接变化，在变化中寻求机遇'
        },
        {
          title: '专业严谨',
          desc: '全方位思考，注重细节，追求高品质'
        },
        {
          title: '阳光',
          desc: '为人正直，坚守诚信 ，勇于担当'
        },
        {
          title: '拼搏',
          desc: '勤奋努力，不畏艰难，永争第一'
        },
        {
          title: '感恩',
          desc: '换位思考，对他人的付出表示感谢'
        }
      ],
      swiperList: [
        {
          imgUrl: require('../../assets/images/weicai/aboutWe/activity1.jpg'),
          title: '公司年会',
          desc: '微财数科最重要的年度盛会，会上将向员工传递公司战略、业务布局与管理思路，表彰优秀团队，并由员工们表演精彩的自制节目。'
        },
        {
          imgUrl: require('../../assets/images/weicai/aboutWe/activity2.jpg'),
          title: '团建活动',
          desc: '每年，微财数科都会组织面向全体员工的团建活动，增进新老员工之间的感情交流，提高团队凝聚力。'
        },
        {
          imgUrl: require('../../assets/images/weicai/aboutWe/activity3.jpg'),
          title: '文体俱乐部',
          desc: '为关爱员工健康，丰富业余生活，微财数科成立了篮球、羽毛球、瑜伽、BODYCOMBAT等文体俱乐部。'
        },
        {
          imgUrl: require('../../assets/images/weicai/aboutWe/activity4.jpg'),
          title: '文化节',
          desc: '微财人的节日，文化节期间，微财人会参加公司举办的各种庆祝活动，并将文化的信念传承下去。'
        },
        {
          imgUrl: require('../../assets/images/weicai/aboutWe/activity5.jpg'),
          title: '读书会',
          desc: '为了创造更好的学习型组织氛围，搭建相互学习、共同成长的平台，微财数科推出了WE享阅读-季度读书分享会。'
        },
        {
          imgUrl: require('../../assets/images/weicai/aboutWe/activity6.jpg'),
          title: '节日活动',
          desc: '在元宵节、妇女节、端午节、中秋节、程序员节等节日，微财数科会面向员工组织丰富多样的节日活动。'
        }
      ]
    }
  },
  mounted () {
    window.scrollTo(0, 0)

    // eslint-disable-next-line no-undef
    this.mySwiper = new Swiper('.swiper-container', {
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })
  },
  methods: {
    prev () {
      this.mySwiper.slidePrev()
    },
    next () {
      this.mySwiper.slideNext()
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/style/weicai.less";
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/pages/aboutWe/aboutWe.vue